export default {
  itemsOnPage: 'components.views.list-view.items-on-page'
}
